import TYPES from "./types";
import { axiosInstance } from "../../../axiosInstance";
import { returnErrors, clearErrors } from "../../../actions/errorActions";
import API from "../API";

const {
  GET_FEEDBACK_LOADING,
  GET_FEEDBACK_SUCCESS,
  GET_FEEDBACK_FAIL,
} = TYPES;

// Get Service Feedback

export function getFeedbacks(user_id = null, morphType = null, morphID = null, page = null, limit = null) {
  return async function getFeedbacksWithDispatch(dispatch) {
    dispatch(clearErrors());
    dispatch({
      type: GET_FEEDBACK_LOADING,
    });
    try {
        let response = await axiosInstance.get(`${API.Feedbacks}?${user_id ? `&user_id=${user_id}` : null}${morphType ? `&morphType=${morphType}`: null}${morphID ? `&morphID=${morphID}` : null}`);
        if(response.status !== 200){
            dispatch({
                type: GET_FEEDBACK_FAIL,
            });
            throw Error({
                response: {
                    data: "Other Errors",
                    status: "Other Errors"
                },
            })
        }else{
          dispatch({
            type: GET_FEEDBACK_SUCCESS,
            payload: response.data
          });
        }
    } catch (error) {
        if (error.response && error.response.data) {
            dispatch(returnErrors(error.response.data, error.response.status, 'GET_FEEDBACK_FAIL'));
            dispatch ({ 
                type: GET_FEEDBACK_FAIL 
            });
        }else{
          let errorJson = JSON.stringify(error);
          let errorParsed = JSON.parse(errorJson);
          return (
              dispatch(returnErrors(errorParsed.message, "Network Error", 'GET_FEEDBACK_FAIL')),
              dispatch ({ 
                  type: GET_FEEDBACK_FAIL 
              })
          )
        }
    }
  };
}
